import type { HttpResult } from './types';

export function identifyHttpResult(statusCode: number): HttpResult {
  if (statusCode >= 100 && statusCode < 200) {
    return 'information';
  }
  if (statusCode >= 200 && statusCode < 300) {
    return 'success';
  }
  if (statusCode >= 300 && statusCode < 400) {
    return 'redirect';
  }
  if (statusCode >= 400 && statusCode < 500) {
    return 'clientError';
  }
  if (statusCode >= 500 && statusCode < 600) {
    return 'serverError';
  }

  throw new Error(`Unknown http status code: ${statusCode}`);
}
